import { render, staticRenderFns } from "./NetdocModule.vue?vue&type=template&id=299d4556&scoped=true"
import script from "./NetdocModule.vue?vue&type=script&lang=js"
export * from "./NetdocModule.vue?vue&type=script&lang=js"
import style0 from "./NetdocModule.vue?vue&type=style&index=0&id=299d4556&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299d4556",
  null
  
)

export default component.exports